module.exports = __webpack_public_path__ + "img/relatorio-rastreabilidade.dc2923e1.svg";